import PropTypes from 'prop-types';
import styles from './FJVideoRemoveBgCustomExport.module.less';
import FJArrowBack from '../../../../assets/svg/back.svg?react';
import FJLocalStore from '../../../../store/FJLocalStore';
import FJConstant from '../../../../constants/FJConstant';
import FJArcProgress from '../../../../common/components/FJArcProgress/FJArcProgress';
import FJButton, { FJButtonType } from '../../../../common/components/FJButton/FJButton';
import ExportSuccessIcon from '../../../../assets/svg/export-success.svg?react';
import FJIconButton from '../../../../common/components/FJIconButton/FJIconButton';
import EditIcon from '../../../../assets/svg/edit-1.svg?react';
import RemoveMoreIcon from '../../../../assets/svg/edit.svg?react';
import FJFileUpload from '../../../../common/components/FJFileUpload/FJFileUpload';
import { FJVideoRemoveBgDataConfig } from '../../../../config/dataConfig/FJVideoRemoveBgDataConfig';
import FJFileIcon from '../../../../assets/svg/download-fail.svg?react';
import FJDownloadIcon from '../../../../assets/svg/download.svg?react';

const FJVideoRemoveBgCustomExport = ({ status, progress, goToBack, download, removeMore, cancelExport }) => {
    return (
        <div className={styles.container}>
            <div className={styles.header_title}>
                <FJArrowBack className={styles.header_title_back} onClick={goToBack} />
                {FJLocalStore._('download')}
            </div>

            <div className={styles.content}>
                {status === FJConstant.START && (
                    <div className={styles.progress_box}>
                        <FJArcProgress
                            percent={progress}
                            boxClassName={styles.progress}
                            valueClassName={styles.progress_text}
                            fractionDigits={0}
                        />
                        <div className={styles.downloading_text}>{FJLocalStore._('downloading')}</div>
                        <FJButton className={styles.cancel} text={FJLocalStore._('cancel')} onClick={cancelExport} />
                    </div>
                )}

                {status === FJConstant.SUCCESS && (
                    <div className={styles.exported_box}>
                        <ExportSuccessIcon />
                        <div className={styles.exported_text}>
                            {FJLocalStore._('congratulations-exported-successfully')}
                        </div>
                        <div className={styles.exported_tips}>
                            {FJLocalStore._('problems-with-the-download-please-click-download')
                                .split('<a>')
                                .map((item, index) => {
                                    if (index === 1) {
                                        return (
                                            <span key={index}>
                                                <a onClick={download}>{FJLocalStore._('download')}</a>
                                            </span>
                                        );
                                    }
                                    return <span key={index}>{item}</span>;
                                })}
                        </div>

                        <div className={styles.download_btn_box}>
                            <FJIconButton
                                className={styles.edit_btn}
                                icon={<EditIcon />}
                                type={FJButtonType.GRADIENT}
                                text={FJLocalStore._('edit-video')}
                                onClick={goToBack}
                            />

                            <FJFileUpload onUpload={removeMore} accept={FJVideoRemoveBgDataConfig.ACCEPT_FILE_TYPE}>
                                <FJIconButton
                                    className={styles.remove_btn}
                                    icon={<RemoveMoreIcon />}
                                    text={FJLocalStore._('remove-more-video')}
                                />
                            </FJFileUpload>
                        </div>
                    </div>
                )}

                {status === FJConstant.ERROR && (
                    <div className={styles.error_box}>
                        <FJFileIcon />
                        <div className={styles.error_text}>{FJLocalStore._('download-error-please-try-again')}</div>
                        <FJButton
                            text={FJLocalStore._('download')}
                            type={FJButtonType.GRADIENT}
                            onClick={download}
                            className={styles.error_btn}
                            icon={<FJDownloadIcon className={styles.error_btn_icon} />}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

FJVideoRemoveBgCustomExport.propTypes = {
    status: PropTypes.string.isRequired,
    progress: PropTypes.number.isRequired,
    goToBack: PropTypes.func.isRequired,
    download: PropTypes.func.isRequired,
    removeMore: PropTypes.func,
    cancelExport: PropTypes.func.isRequired,
};

export default FJVideoRemoveBgCustomExport;
